import { createSlice } from "redux-starter-kit";

export const pubPreviewSlice = createSlice({
  slice: "pubPreviewSlice",
  initialState: { showModal: false, publication: {} },
  reducers: {
    showPreview: (state, action) => {
      state.publication = action.payload;
      state.showModal = true;
    },
    hidePreview: (state, action) => {
      state.showModal = false;
    },
  },
});
